import { NotificationsContent } from '../../components/popover/content/NotificationsContent'
import { MainLayout } from '../../components/layout/MainLayout'

export function NotificationsPage() {
  return (
    <MainLayout
      redirectOnSelect={false}
      hideBack={false}
      contentClassName="mt-0"
      className="h-screen min-h-auto"
      heightClassName="h-full"
    >
      <NotificationsContent />
    </MainLayout>
  )
}
